export default __webpack_public_path__ + "static/media/agenda.3385761c.svg";